import React, { useEffect } from 'react';
import { useAppSelector } from '@web-common/state/createStore';
import { popupIdPrefixSelectorNew } from '@web-common/popup_state/selector';
import styles from './hasMaskGuide.module.scss';
import { getIn18Text } from 'api';
const HasMaskFooter = props => {
    const { guideId, step, onStep, okText = getIn18Text('ZHIDAOLE'), onClose, keyboard } = props;
    const winPrefix = 'HINT_FOR_SUB_MODULE/' + guideId;
    const winAll = useAppSelector(state => popupIdPrefixSelectorNew(state, winPrefix));
    useEffect(() => {
        const keydownChange = (e) => {
            if (e.keyCode === 27 && keyboard) {
                handleNext();
            }
        };
        window.addEventListener('keydown', keydownChange);
        return () => {
            window.removeEventListener('keydown', keydownChange);
        };
    }, [keyboard]);
    const handleNext = () => {
        onClose && onClose(onStep >= (winAll === null || winAll === void 0 ? void 0 : winAll.length));
    };
    const handleSkip = () => {
        onClose && onClose(true);
    };
    return (React.createElement("div", { className: styles.footer },
        step ? (React.createElement("span", null,
            onStep,
            "/", winAll === null || winAll === void 0 ? void 0 :
            winAll.length)) : (React.createElement("span", null)),
        React.createElement("div", { className: styles.footerRight },
            (winAll === null || winAll === void 0 ? void 0 : winAll.length) > 2 && (React.createElement("span", { className: styles.skip, onClick: handleSkip }, getIn18Text('TIAOGUO'))),
            React.createElement("button", { className: styles.butt, onClick: handleNext }, onStep >= (winAll === null || winAll === void 0 ? void 0 : winAll.length) ? okText : getIn18Text('XIAYIBU')))));
};
export default HasMaskFooter;
